import {
  AUTO_STYLE, animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { ChangeDetectionStrategy, Component, NgZone, OnChanges, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import * as moment from "moment";
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from "ngx-toastr";
import { interval, Subscription, timer } from "rxjs";
import { openFullscreen } from "../../../assets/javascript/demo";
import { environment } from "../../../environments/environment";
import {
  appConstants,
} from "../../core/config/constant";
import {
  IAccountModel,
  IAddressModel,
  ICompanyModel,
  ICompanyShippingSiteViewModel,
  IContactViewModel,
  ILanguageModel,
  ILoginAccountModel,
  ILoginNewUserModel,
  INewUserModel,
  IPostRegisterAccountModel,
  Iuser,
} from "../../core/models/accountModel";
import { ICountryViewModel, IMessageHubModel } from "../../core/models/globalMaster";
import { ISourcingAdvisorModel } from "../../core/models/profileModel";
import {
  IMarkSupplierRFQViewModel,
  IRatingResponseViewModel,
} from "../../core/models/rfqModel";
import { IMyAccountViewModel } from "../../core/models/supplierProfileModel";
import { AccountService } from "../../core/services/account/account.service";
import { MasterService } from "../../core/services/master/master.service";
import { AppMessageService } from "../../core/services/messages/message.service";
import { ProfileService } from "../../core/services/profile/profile.service";
import { RfqService } from "../../core/services/rfq/rfq.service";
import { SessionExpireService } from "../../core/services/session-expire/session-expire.service";
import { SupplierService } from "../../core/services/supplier/supplier.service";
import { CustomValidatorService } from "../../core/services/validator/custom-validator.service";
import { FeedbackInterceptionService } from "../../core/services/feedback-interception.service";
import { MenuItems } from "../../shared/menu-items/menu-items";

import { HttpClient } from "@angular/common/http";
import { AppUtil } from "../../../app/app.util";
import { JwtTokenService } from "../../../app/component/SSO/services/jwt-token.service";
import { IpService } from "../../../app/v2/shared/ip.service";
import { SSOService } from "./../../component/SSO/services/sso.service";
import { VersionInfo } from "../../../app/v2/shared/api-version.service";
import { TalkJSService } from "../../core/services/talkjs/talkjs.service";
import {
  isBuyerPlatformAdmin,
  isBuyerPlatformMember,
  shouldBypassBuyerLeftNavLock
} from "../../v2/buyer/utils/buyer-platform-access.util";

@Component({
  selector: "app-admin",
  templateUrl: "./admin.component.html",
  styleUrls: ["./admin.component.scss"],
  providers: [JwtTokenService],
  changeDetection: ChangeDetectionStrategy.Default,
  animations: [
    trigger("notificationBottom", [
      state(
        "an-off, void",
        style({
          overflow: "hidden",
          height: "0px",
        })
      ),
      state(
        "an-animate",
        style({
          overflow: "hidden",
          height: AUTO_STYLE,
        })
      ),
      transition("an-off <=> an-animate", [animate("400ms ease-in-out")]),
    ]),
    trigger("slideInOut", [
      state(
        "in",
        style({
          width: "300px",
        })
      ),
      state(
        "out",
        style({
          width: "0",
        })
      ),
      transition("in => out", animate("400ms ease-in-out")),
      transition("out => in", animate("400ms ease-in-out")),
    ]),
    trigger("mobileHeaderNavRight", [
      state(
        "nav-off, void",
        style({
          overflow: "hidden",
          height: "0px",
        })
      ),
      state(
        "nav-on",
        style({
          height: AUTO_STYLE,
        })
      ),
      transition("nav-off <=> nav-on", [animate("400ms ease-in-out")]),
    ]),
    trigger("fadeInOutTranslate", [
      transition(":enter", [
        style({
          opacity: 0,
        }),
        animate(
          "400ms ease-in-out",
          style({
            opacity: 1,
          })
        ),
      ]),
      transition(":leave", [
        style({
          transform: "translate(0)",
        }),
        animate(
          "400ms ease-in-out",
          style({
            opacity: 0,
          })
        ),
      ]),
    ]),
  ],
})
export class AdminComponent implements OnInit, OnDestroy {
  logoDetail: any = {
    ready: false,
    isSupplierRebranding: false,
    routerLink: '/dashboard/buyer/default/',
    imgSrc: "",
    initials: "",
    companyFullName: "",
  };
  generatedJWTForMaterials: any;
  iMessageHubModelList: Array<IMessageHubModel> = [];
  iContactViewModel: IContactViewModel;
  iContactViewModel1: IContactViewModel;
  iLanguageModel: ILanguageModel;
  iCompanyModel: ICompanyModel;
  iAddressModel: IAddressModel;
  iNewUserModel: INewUserModel;
  iLoginNewUserModel: ILoginNewUserModel;
  registerSupplierForm: FormGroup;
  iuser: Iuser;
  labelFocus: string;
  header: string;
  showBell: boolean;
  showMessage: boolean;
  selectedItems = [];
  supplierLogoPath = "assets/company/avatar-manu-basic.svg";
  iCompanyShippingSiteViewModel: ICompanyShippingSiteViewModel;
  iAccountModel: IAccountModel;
  iLoginAccountModel: ILoginAccountModel;
  iPostModel: IPostRegisterAccountModel;
  countrysettings = {};
  applicableRoles: string[];
  messageCount: number;
  notoficationCount: number;
  unreadChatCount: number = 0;
  showProgressBar = false;
  isCountAvailable: boolean;
  isCountryMultiSelectTouched = false;
  errorOnCountryMultiSelect = false;
  userCreatedDateString = " ";
  isAdminUser: boolean;
  rolName: string;
  npsRatingPopupTitle = "";
  isNPSPupupShow = false;
  isAccountUpgradeReqSent = false;
  accountUpgradeMessage = "";
  ratingsPopupLogoPath = "";
  iContactViewModelNPSModel: IContactViewModel;
  iCompanyModelNPSModel: ICompanyModel;
  currentlogoPath: string;
  logoPathToShow: string;
  headerImagePreviewSrc: string = null;
  defaultAwsPath = "";
  radio1: number;
  fromContactOfMessage: number;
  toContactOfMessage: number;
  iRatingResponseViewModel: IRatingResponseViewModel;
  isCompanyIdPresent: boolean;
  toShowBillingMenu: boolean = false;
  toShowLicensesMenu: boolean = false;
  toShowDownloadsMenu: boolean = false;
  showScheduleDemo: boolean = false;
  public navType: string;
  public themeLayout: string;
  public verticalPlacement: string;
  iSourcingAdvisorModel: ISourcingAdvisorModel;
  public verticalLayout: string;
  public pcodedDeviceType: string;
  public verticalNavType: string;
  public verticalEffect: string;
  public vnavigationView: string;
  public freamType: string;
  public sidebarImg: string;
  public sidebarImgType: string;
  public layoutType: string;

  public headerTheme: string;
  public pcodedHeaderPosition: string;

  public liveNotification: string;
  public liveNotificationClass: string;

  public profileNotification: string;
  public profileNotificationClass: string;

  public chatSlideInOut: string;
  public innerChatSlideInOut: string;

  public searchWidth: number;
  public searchWidthString: string;

  public navRight: string;
  public windowWidth: number;
  public chatTopPosition: string;

  public toggleOn: boolean;
  public navBarTheme: string;
  public activeItemTheme: string;
  public pcodedSidebarPosition: string;

  public menuTitleTheme: string;
  public dropDownIcon: string;
  public subItemIcon: string;
  iCountryColl: ICountryViewModel[];
  public configOpenRightBar: string;
  public displayBoxLayout: string;
  public isVerticalLayoutChecked: boolean;
  public isSidebarChecked: boolean;
  public isHeaderChecked: boolean;
  public headerFixedMargin: string;
  public sidebarFixedHeight: string;
  public itemBorderStyle: string;
  public subItemBorder: boolean;
  public itemBorder: boolean;
  public loggedUsername: string;
  public loggedUserRole: string;
  iRFQViewModelColl: IMarkSupplierRFQViewModel;
  public config: any;
  userType: string;
  buyerSupplier: boolean;
  SupplierBuyer: boolean;
  isSupplier: boolean;
  isPaidContract: string;
  iMyAccountViewModel: IMyAccountViewModel;
  isLoader: boolean;
  isUpgradeBtn: boolean;
  isAccountUpgradereqSent: boolean;
  accountUpgradereqMessage: string;
  isDownloadReceipt: boolean;
  isMQSEnable: string;
  disabled: boolean;
  modalSubscription: Subscription;
  year = new Date().getFullYear();
  toShowContactModel: boolean = false;
  disabledButton: boolean = false;
  isNotificationLoader: boolean = false;
  loading: boolean = false;
  toShowNewIcon = false;
  showSessionModel: boolean = false;
  subscribeRef: Subscription;
  timer: any;
  isCount: number = 0;
  isReadyForMoreImg: boolean = false;
  isEligibleForGrowthPackage: any;
  isQuoteRfq: boolean;
  showUpgradeAccountModal: boolean;
  remainingStatus: boolean = false;
  refreshCountShowStatus: boolean = false;
  userLocation: string = null;

  toShowLeftImg: boolean = false;
  ipAddress: string;
  newMessageCount: number = 0;
  newNotifications: number = 0;
  isVisionUser: any;
  willDoLaterCount: any;
  isGetSubmited: boolean = false;
  noOfDaysLeft: number = 0;
  isRemainingTileShow: boolean;
  accountType: string;
  isProfessionalPackage: boolean;
  unlockedRfq: any;
  showUnlockRfq: boolean;

  showMfgContactRfqsLeftMenu: boolean;
  sidebarFixedNewHeight: string;
  //menuList: any;
  leftMenu: any;
  sidebarMenuLoading: boolean = true;
  sidebarSkeletonMenu: any[];
  showBubble: boolean = false;
  private rfqCountSubscription: Subscription;
  private versionUpdateDetected: boolean = false;
  private versionUpdateListener: (event: any) => void;
  private routerEventsSubscription: Subscription;
  currentRoute: string = '';
  /** True when current route sets `data.hideAppChrome` (standalone pages without app header/sidebar). */
  hideAppChrome = false;
  /** Supplier Network invitees: show "My Buyers" below Dashboard in the left nav. */
  showSupplierNetworkMyBuyersMenu = false;

  constructor(
    public menuItems: MenuItems,
    private router: Router,
    private toastr: ToastrService,
    private messageService: AppMessageService,
    private masterService: MasterService,
    private fb: FormBuilder,
    private accountService: AccountService,
    private customValidatorsService: CustomValidatorService,
    private supplierService: SupplierService,
    private ngZone: NgZone,
    private rfqService: RfqService,
    private profileService: ProfileService,
    private sessionExpireService: SessionExpireService,
    private http: HttpClient,
    private cookieService: CookieService,
    private ipService: IpService,
    private ssoService: SSOService,
    private activatedRoute: ActivatedRoute,
    private feedbackInterceptionService: FeedbackInterceptionService,
    private talkjsService: TalkJSService
  ) {

    this.rfqService.set(false, "isSideMenuVisible");
    const sidebarSkeletonLabels = [
      "Opportunities",
      "Quotes",
      "Orders",
      "Contacts",
      "Messages",
      "Notifications",
      "Settings"
    ];
    this.sidebarSkeletonMenu = sidebarSkeletonLabels.map((name) => ({
      name,
      icon: "ti-menu",
      hasChildren: false,
      opened: false,
      children: []
    }));
    this.iMessageHubModelList = [];
    this.initJobPostingModel();
    this.GetProfileDetails();
    this.getSubmittedRFQCount();
    this.navType = "st2";
    this.isCountAvailable = false;
    this.isCompanyIdPresent = false;
    this.disabled = false;
    this.labelFocus = "no";
    this.showBell = false;
    this.showMessage = false;
    this.themeLayout = "vertical";
    this.verticalPlacement = "left";
    this.verticalLayout = "wide";
    this.pcodedDeviceType = "desktop";
    this.verticalNavType = "expanded";
    this.verticalEffect = "shrink";
    this.vnavigationView = "view1";
    this.freamType = "theme1";
    this.sidebarImg = "false";
    this.sidebarImgType = "img1";
    this.layoutType = "light";
    this.messageCount = 0;
    this.notoficationCount = 0;
    this.headerTheme = "themelight5";
    this.pcodedHeaderPosition = "fixed";
    AppStorageUtil.setItem("NotifiClicked", "false");
    this.liveNotification = "an-off";
    this.profileNotification = "an-off";

    this.chatSlideInOut = "out";
    this.innerChatSlideInOut = "out";

    this.searchWidth = 0;

    this.navRight = "nav-on";

    this.windowWidth = browserWindow.innerWidth;
    this.setHeaderAttributes(this.windowWidth);
    this.showUpgradeAccountModal = false;

    this.toggleOn = true;
    this.navBarTheme = "themelight1";
    this.activeItemTheme = "theme10";
    this.pcodedSidebarPosition = "fixed";
    this.menuTitleTheme = "theme1";
    this.dropDownIcon = "style3";
    this.subItemIcon = "style7";
    this.displayBoxLayout = "d-none";
    this.isVerticalLayoutChecked = false;
    this.isSidebarChecked = true;
    this.isHeaderChecked = true;
    this.headerFixedMargin = "4.2rem";
    this.isAdminUser = false;
    let IsPremiumEncrypt = AppStorageUtil.getItem("IsPremium");
    this.isPaidContract = this.profileService.decrypt(IsPremiumEncrypt);
    this.itemBorderStyle = "none";
    this.subItemBorder = true;
    this.itemBorder = true;
    this.buyerSupplier = false;
    this.SupplierBuyer = false;
    this.setMenuAttributes(this.windowWidth);
    this.setHeaderAttributes(this.windowWidth);
    this.loggedUsername = AppStorageUtil.getItem("User2");
    this.userType = AppStorageUtil.getItem("Usertype");
    this.isVisionUser = AppStorageUtil.getItem("isLoginFromVision");
    this.accountService.getMessage().subscribe((message) => {
      if (message) {
        this.ngZone.run(() => {
          this.userType = AppStorageUtil.getItem("Usertype");
          this.loggedUserRole = this.userType;
          this.applicableRoles = JSON.parse(
            AppStorageUtil.getItem("applicableRoles")
          );
          this.buyerNavUnlockHintLatched = false;
          this.buyerNavUnlockFromPoll = false;
          this.buyerAiLeftNavUnlockPollAttempt = 0;
          this.stopBuyerAiLeftNavUnlockPolling();
          this.rfqService.set("", "CompanyName");
          this.rfqService.set(0, "companyId");
          let IsPremiumEncrypt = AppStorageUtil.getItem("IsPremium");
          this.isPaidContract = this.profileService.decrypt(IsPremiumEncrypt);
          this.logoPathToShow = "";
          this.applicableRole();
          this.refreshSupplierNetworkMyBuyersMenu();
          this.GetProfileDetails();
          this.isAdmin();
        });
      }
    });
    this.applicableRoles = JSON.parse(AppStorageUtil.getItem("applicableRoles"));
    this.applicableRole();
    this.isAdmin();
    this.iRFQViewModelColl = {
      rfqId: 0,
      rfqName: "",
      contactIdEncrypt: "",
      awardRfqPendingAcceptenceCount: 0,
      buyerContactId: 0,
      declineQuotesCount: 0,
      ndaToApproveCount: 0,
      ndaToSignRequireResignCount: 0,
      ndaToSignSupplierDeclinedCount: 0,
      quotesInProgressRfqCount: 0,
      specialInvitedRfqUnreadCount: 0,
      contactId: 0,
      isRfqDisLike: false,
      rfqStatusId: 0,
      rfqStatus: "",
      rfqCreatedOn: "",
      quotesNeededBy: null,
      awardDate: "",
      partsPrimaryFileName: "",
      partName: "",
      partQty: 0,
      partQtyUnit: "",
      partsMaterialName: "",
      partCategoryName: "",
      postProductionProcessName: "",
      buyerName: "",
      errorMessage: "",
      result: false,
      allRfqCount: 0,
      likedRfqCount: 0,
      specialInviteRfqCount: 0,
      quotesRfqCount: 0,
      awardedRfqCount: 0,
      newMessages: 0,
      reQuoteRfq: 0,
      followedBuyersRfqCount: 0,
      awardDeclinedCount: 0,
      ndaBuyerDeclined: 0,
      ndaRequireResign: 0,
      rfqType: "",
      isRfqLike: false,
      npsScore: 0,
      rfqThumbnail: "",
      companyLogoPath: "",
      companyName: "",
      specialInstructions: "",
      profileViewCount: 0,
      markForQuotingCount: 0,
      newQuotesCount: 0,
      city: "",
      country: "",
      state: "",
      unviewedMagicLeadsCount: 0,
      manufacturingLocationId: 0,
      manufacturingLocation: "",
      deliveryDate: "",
      newNotifications: 0,
    };

    this.loggedUserRole = AppStorageUtil.getItem("Usertype");
    this.npsRatingPopupTitle = "";
    this.isNPSPupupShow = false;
    this.isAccountUpgradeReqSent = false;
    this.accountUpgradeMessage = "";
    this.radio1 = 0;
    this.isAccountUpgradereqSent = false;
    this.isDownloadReceipt = false;
    this.isLoader = false;
    this.isUpgradeBtn = false;
    this.iMyAccountViewModel = {
      companyId: 0,
      contactId: 0,
      istrail: true,
      accountType: "",
      membership: "",
      price: 0,
      paymentMethod: "",
      paymentFrequency: "",
      paymentAmount: 0,
      startDate: "0001-01-01T00:00:00",
      endDate: "0001-01-01T00:00:00",
      autoRenewal: false,
      errorMessage: "",
      result: false,
      pageName: "admin component",
      rfqId: 0,
      toAlternateEmailId: "",
    };
    this.menuHeadrsAsPerRole();
  }

  menuHeadrsAsPerRole() {
    this.checkUserLocation();
    this.logoPathReload();
  }

  checkSupplierRegistrationForms() {
    const firstName = this.registerSupplierForm.value.sFirstName;
    const lastName = this.registerSupplierForm.value.sLastName;
    const phoneNo = this.registerSupplierForm.value.sPhoneNo;
    const sCompany = this.registerSupplierForm.value.sCompany;
    const sCountryId = this.registerSupplierForm.value.scontryId;
    const sPostalCode = this.registerSupplierForm.value.sPostalCode;
    if (
      sCompany.trim() === "" ||
      sCountryId === 0 ||
      sCountryId === undefined ||
      sCountryId === "0" ||
      sCountryId.trim() === "" ||
      sPostalCode.trim() === "" ||
      firstName.trim() === "" ||
      lastName.trim() === "" ||
      phoneNo.trim() === ""
    ) {
      return true;
    } else {
      return false;
    }
  }
  full() {
    openFullscreen();
  }

  get loggedCompanyId() {
    // tslint:disable-next-line:radix
    const Id = AppStorageUtil.getItem("loggedCompanyId");
    if (Id) {
      // tslint:disable-next-line:radix
      return parseInt(AppStorageUtil.getItem("loggedCompanyId"));
    } else {
      return 0;
    }
  }
  checkOnOpen() {
    this.isCountryMultiSelectTouched = true;
    this.setFocus("sCountryId");
  }
  onStateSelect(item: any) {
    this.iContactViewModel1.address.countryId = item.countryId;
    this.errorOnCountryMultiSelect = false;
  }

  createForm() {
    if (
      this.iContactViewModel1.company != null &&
      this.iContactViewModel1.company !== undefined
    ) {
      this.registerSupplierForm = this.fb.group({
        sFirstName: ["", Validators.required],
        sLastName: ["", Validators.required],
        sPhoneNo: ["", Validators.required],
        sCompany: [this.iContactViewModel1["company"].name],
        scontryId: ["", Validators.required],
        sPostalCode: ["", Validators.required],
      });
    } else {
      this.registerSupplierForm = this.fb.group({
        sFirstName: ["", Validators.required],
        sLastName: ["", Validators.required],
        sPhoneNo: ["", Validators.required],
        sCompany: [""],
        scontryId: ["", Validators.required],
        sPostalCode: ["", Validators.required],
      });
    }
  }
  onRegister() {
    if (
      this.iContactViewModel1.companyId === null ||
      this.iContactViewModel1.companyId === 0
    ) {
      this.toastr.error(
        "Please update Company details first from Contact Information section",
        "Error!"
      );
    } else {
      this.disabled = true;
      this.loading = true;
      this.iContactViewModel1.address.countryId =
        this.registerSupplierForm.value.scontryId;
      this.iContactViewModel1.address.postalCode =
        this.registerSupplierForm.value.sPostalCode;
      this.iContactViewModel1.firstName =
        this.registerSupplierForm.value.sFirstName;
      this.iContactViewModel1.lastName =
        this.registerSupplierForm.value.sLastName;
      this.iContactViewModel1.phoneNo =
        this.registerSupplierForm.value.sPhoneNo;
      if (this.userType === "Supplier") {
        this.iContactViewModel1.isBuyer = true;
        this.rolName = "BuyerAdmin";
      } else {
        this.iContactViewModel1.isBuyer = false;
        this.rolName = "SellerAdmin";
      }
      this.iContactViewModel1.userIpAddress = this.ipAddress;
      this.accountService.addConvertConatct(this.iContactViewModel1).subscribe(
        (res) => {
          AppStorageUtil.setItem(
            "applicableRoles",
            JSON.stringify(res.currentUserRole)
          );
          let IsPrimiumEncrypt = this.profileService.encrypt(
            JSON.stringify(res.contactViewModel.isPremium)
          );
          AppStorageUtil.setItem("IsPremium", IsPrimiumEncrypt.toString());
          this.toastr.success("New User Register Successfully !!", "");
          this.switchAccount(this.rolName);
        },
        (error) => {
          this.toastr.warning(error.error.errorMessage, "Warning!");
          this.disabled = false;
          this.loading = false;
        }
      );
    }
  }

  switchAccount(Role: string) {
    // this.getSubmittedRFQCount();
    this.isGetSubmited = true;
    const userId = AppStorageUtil.getItem("userId");
    if (
      userId !== "null" &&
      userId !== null &&
      userId !== undefined &&
      userId !== "undefined"
    ) {
      let isLoginFromVision;
      if (AppStorageUtil.getSessionItem("isLoginFromVision") == "true") {
        isLoginFromVision = true;
      } else {
        isLoginFromVision = false;
      }
      this.accountService
        .swicthContact(userId, Role, isLoginFromVision)
        .subscribe(
          (data) => {
            this.loading = false;
            this.profileService.getProfileForLoginDetails(data['contactIdEncrypt'].toString()).subscribe(
              result2 => {
                this.iContactViewModel = result2;
                AppStorageUtil.setItem('iContactViewModel', JSON.stringify(this.iContactViewModel));
                this.updateBuyerPlatformMenuVisibility(result2);
              });
            if (
              data.isGoldPlatinumViaStripe != null &&
              data.isGoldPlatinumViaStripe != undefined &&
              data.isGoldPlatinumViaStripe != ""
            ) {
              AppStorageUtil.setItem("isStripUser", data.isGoldPlatinumViaStripe);
            } else {
              AppStorageUtil.setItem("isStripUser", "false");
            }
            if (
              data.isLiveQuoteBetaTried != undefined &&
              data.isLiveQuoteBetaTried != null &&
              data.isLiveQuoteBetaTried != ""
            ) {
              AppStorageUtil.setItem(
                "isQMSTrailModelShown",
                data.isLiveQuoteBetaTried
              );
            } else {
              AppStorageUtil.setItem("isQMSTrailModelShown", "false");
            }
            AppStorageUtil.removeItem("manufacturingLocation");
            AppStorageUtil.setItem(
              "manufacturingLocation",
              data.manufacturingLocation
            );
            this.checkUserLocation();
            AppStorageUtil.setItem(
              "applicableRoles",
              JSON.stringify(data.currentUserRole)
            );
            AppStorageUtil.setItem(
              "LoggedId",
              data.contactViewModel.contactId.toString()
            );
            AppStorageUtil.setItem(
              "LoggedIdEncript",
              data["contactIdEncrypt"].toString()
            );
            AppStorageUtil.setItem(
              "loggedCompanyId",
              data.contactViewModel.companyId.toString()
            );
            if (data.user?.userName) {
              AppStorageUtil.setItem("User2", data.user.userName);
            }
            this.profileService.isBuyerAiEnabled = null;
            this.profileService.rfqForm2Enabled = undefined;
            AppStorageUtil.setItem("iContactViewModel", null);
            if (data.contactViewModel.isRFQCreated === true) {
              AppStorageUtil.setItem("isNewUser", "false");
            } else {
              AppStorageUtil.setItem("isNewUser", "true");
            }
            if (data.contactViewModel.isBuyer === true) {
              this.isSupplier = false;
              AppStorageUtil.removeItem("AccountType");
              AppStorageUtil.setItem("isMqsEnabled", "false");
              AppStorageUtil.setItem("Usertype", "Buyer");
              this.accountService.sendMessage("Buyer");
              this.isSupplier = false;
              this.disabled = false;
              this.getEmailVerificationStatus();
              this.getSubmittedRFQCount();
            } else {
              appConstants.settingDefault.decimalValueDefault =
                data.defaultNoOfDecimalPlaces;
              AppStorageUtil.setItem(
                "applicableRoles",
                JSON.stringify(data.currentUserRole)
              );
              AppStorageUtil.setItem(
                "isCapabilitiesFilled",
                data.contactViewModel.isCapabilitiesFilled.toString()
              );
              AppStorageUtil.setItem(
                "isCompanyProfileFilled",
                data.contactViewModel.isCompanyProfileFilled.toString()
              );
              this.isSupplier = false;
              this.disabled = false;
              // this.router.navigate(['dashboard/supplier/ecommerce']);
              this.router
                .navigateByUrl("", { skipLocationChange: true })
                .then(() => {
                  if (this.userLocation === 'US' || this.userLocation === 'Canada') {
                    this.router.navigate(['dashboard/supplier']);
                  } else {
                   this.router.navigate(['dashboard/supplier/ecommerce']);
                  }
                });
              AppStorageUtil.setItem("Usertype", "Supplier");
              let IsPrimiumEncrypt = this.profileService.encrypt(
                JSON.stringify(data.contactViewModel.isPremium)
              );
              AppStorageUtil.setItem("IsPremium", IsPrimiumEncrypt.toString());
              AppStorageUtil.setItem(
                "isMqsEnabled",
                JSON.stringify(data.isMqsEnabled)
              );
              AppStorageUtil.setItem("AccountType", data.accountType);
              this.profileService.setopenSwitchRfqCapabilityModel(true);
              this.accountService.sendMessage("Supplier");
            }
            this.rfqService.setRfqAwardEvent(true);
            this.menuHeadrsAsPerRole();
          },
          (error) => {
            this.loading = false;
          }
        );
    } else {
      this.loading = false;
      this.toastr.warning(
        "Your session is expired. Please login again to continue.",
        "Warning!"
      );
      AppStorageUtil.clear();
      this.router.navigateByUrl("/auth/login/simple");
    }
    AppStorageUtil.removeSessionItem("lastSurveyQuestionID");
  }

  resetNPSModuleModel() {
    this.iContactViewModelNPSModel = {
      isLike: false,
      accountEmail: "",
      website: "",
      addressId: 0,
      isLoginFromVision: false,
      originalContactPictureFile: "",
      originalLogoOfCompany: "",
      contactIdEncrypt: "",
      comments: "",
      token: "",
      companyId: 0,
      contactFunction: "",
      contactId: 0,
      createdOn: "",
      emailId: "",
      errorMessage: "",
      facebook: "",
      firstName: "",
      incotermId: 0,
      industry: "",
      industryId: 0,
      isActive: true,
      isAdmin: true,
      isBuyer: true,
      isMailInHtml: true,
      isNotifyByEmail: true,
      languageId: 0,
      lastName: "",
      linkedIn: "",
      modifiedOn: "",
      password: "",
      phoneNo: "",
      recordOriginId: 0,
      result: true,
      roleId: 0,
      showDeltailedRating: true,
      showRfqAwardStat: true,
      title: "",
      tweeter: "",
      userId: "",
      contactPictureFile: "",
      logoOfCompany: "",
      language: null,
      address: null,
      company: this.iCompanyModelNPSModel,
      isVarified: false,
      expiration: null,
      currentPassword: "",
      newPassword: "",
      isRFQCreated: false,
      grantType: "",
      refreshToken: "",
      googleImageUrl: "",
      isCapabilitiesFilled: false,
      isCompanyProfileFilled: false,
      npsScore: 0,
      currentUserRole: [],
      noOfStars: 0,
      isVisionUserRequest: false,
      instagram: "",
    };
    this.iCompanyModelNPSModel = {
      companyId: 0,
      description: "",
      _3dTourUrl: "",
      dunsNumber: "",
      employeeCountRangeId: 1,
      employeeCountRange: "",
      errorMessage: "",
      isActive: true,
      name: "",
      companylogo: "",
      services: "",
      companyToleranceId: 0,
      salesStatusId: 0,
      supplierType: "",
      supplierTypeId: 0,
    };
    this.iRatingResponseViewModel = {
      responseId: 0,
      fromId: 0,
      toId: 0,
      parentId: 0,
      contactName: "",
      imageURL: "",
      createdDate: "2018-12-13T07:52:13.433Z",
      score: "",
      comment: "",
      isLegacyRating: false,
      messageId: 0,
      isNotNowClicked: false,
      errorMessage: "",
      result: false,
      rfqId: 0,
    };
  }
  initJobPostingModel() {
    this.resetNPSModuleModel();
    this.iAccountModel = {
      contact_id: "",
      email: "",
      pwd: "",
      confirmPwd: "",
    };
    this.iNewUserModel = {
      token: "",
      errorMessage: "",
      contactViewModel: this.iContactViewModel,
      result: false,
      isCapabilitiesFilled: false,
      isCompanyProfileFilled: false,
      applicableRoles: [],
      accountType: "",
      isMqsEnabled: false,
      manufacturingLocation: null,
    };

    this.iLoginNewUserModel = {
      errorMessage: "",
      token: "",
      contactId: 0,
      contactIdEncrypt: "",
      user: this.iuser,
      result: false,
      isRFQCreated: false,
      isBuyer: false,
      isBuyerDashboard: null,
      isCapabilitiesFilled: false,
      isCompanyProfileFilled: false,
      applicableRoles: [],
      isPremium: false,
      accountType: "",
      isMqsEnabled: false,
      manufacturingLocation: null,
      totalLoginCount: 0,
      employeeCountRangeId: 0,
    };

    this.iuser = {
      accessFailedCount: 0,
      concurrencyStamp: "",
      email: "",
      emailConfirmed: false,
      firstName: "",
      id: "",
      importedCont_id: 0,
      lastName: "",
      lockoutEnabled: false,
      lockoutEnd: "",
      normalizedEmail: "",
      normalizedUserName: "",
      passwordHash: "",
      phoneNumber: "",
      phoneNumberConfirmed: false,
      securityStamp: "",
      twoFactorEnabled: false,
      userName: "",
    };
    this.iLoginAccountModel = {
      Email: "",
      Password: "",
    };
    this.iPostModel = {
      email: "",
      pwd: "",
    };
    this.iContactViewModel = {
      isLike: false,
      accountEmail: "",
      website: "",
      addressId: 0,
      comments: "",
      originalContactPictureFile: "",
      originalLogoOfCompany: "",
      contactIdEncrypt: "",
      isLoginFromVision: false,
      companyId: 0,
      contactFunction: "",
      contactId: 0,
      createdOn: "",
      emailId: "",
      errorMessage: "",
      facebook: "",
      firstName: "",
      incotermId: 0,
      industry: "",
      industryId: 0,
      isActive: true,
      isAdmin: true,
      isBuyer: true,
      isMailInHtml: true,
      isNotifyByEmail: true,
      languageId: 0,
      lastName: "",
      linkedIn: "",
      modifiedOn: "",
      password: "",
      phoneNo: "",
      recordOriginId: 0,
      result: true,
      roleId: 0,
      showDeltailedRating: true,
      showRfqAwardStat: true,
      title: "",
      tweeter: "",
      userId: "",
      contactPictureFile: "",
      logoOfCompany: "",
      token: "",
      language: null,
      address: null,
      company: null,
      isVarified: false,
      expiration: null,
      currentPassword: "",
      newPassword: "",
      isRFQCreated: false,
      grantType: "",
      refreshToken: "",
      googleImageUrl: "",
      isCapabilitiesFilled: false,
      isCompanyProfileFilled: false,
      npsScore: 0,
      currentUserRole: [],
      noOfStars: 0,
      isVisionUserRequest: false,
      instagram: "",
    };

    this.iLanguageModel = {
      charset: "",
      languageAbr: "",
      languageId: 0,
      languageName: "",
      localeCode: "",
      translated: true,
    };

    this.iCompanyModel = {
      companyId: 0,
      description: "",
      _3dTourUrl: "",
      dunsNumber: "",
      employeeCountRangeId: 1,
      employeeCountRange: "",
      errorMessage: "",
      isActive: true,
      name: "",
      companylogo: "",
      services: "",
      companyToleranceId: 0,
      salesStatusId: 0,
      supplierType: "",
      supplierTypeId: 0,
    };

    this.iAddressModel = {
      address5: "",
      addressId: 0,
      addressType: 1,
      city: "",
      countryId: 0,
      deptAddress: "",
      country: "",
      errorMessage: "",
      isActive: false,
      postalCode: "",
      showInProfile: true,
      showOnlyStateCity: true,
      state: "",
      stateId: 0,
      result: false,
      streetAddress: "",
      companyShippingSiteViewModelList: [this.iCompanyShippingSiteViewModel],
    };
    this.iContactViewModel1 = {
      isLike: false,
      accountEmail: "",
      website: "",
      isLoginFromVision: false,
      addressId: 0,
      originalContactPictureFile: "",
      originalLogoOfCompany: "",
      contactIdEncrypt: "",
      comments: "",
      companyId: 0,
      contactFunction: "",
      contactId: 0,
      createdOn: "",
      emailId: "",
      errorMessage: "",
      facebook: "",
      firstName: "",
      incotermId: 0,
      industry: "",
      industryId: 0,
      isActive: true,
      isAdmin: true,
      isBuyer: false,
      isMailInHtml: true,
      isNotifyByEmail: true,
      languageId: 0,
      lastName: "",
      linkedIn: "",
      modifiedOn: "",
      password: "",
      phoneNo: "",
      recordOriginId: 0,
      result: true,
      roleId: 0,
      showDeltailedRating: true,
      showRfqAwardStat: true,
      title: "",
      tweeter: "",
      userId: "",
      contactPictureFile: "",
      logoOfCompany: "",
      token: "",
      language: null,
      address: this.iAddressModel,
      company: this.iCompanyModel,
      isVarified: false,
      expiration: null,
      currentPassword: "",
      newPassword: "",
      isRFQCreated: false,
      grantType: "",
      refreshToken: "",
      googleImageUrl: "",
      isCapabilitiesFilled: false,
      isCompanyProfileFilled: false,
      npsScore: 0,
      currentUserRole: [],
      noOfStars: 0,
      isVisionUserRequest: false,
      userIpAddress: "",
      instagram: "",
    };

    this.iCompanyShippingSiteViewModel = {
      addressId: 0,
      companyName: "",
      compId: 0,
      contId: 0,
      defaultSite: true,
      siteCreationDate: null,
      siteId: 0,
      siteLabel: "",
      addresses: this.iAddressModel,
    };
  }
  initIco() {
    this.iContactViewModel1 = {
      isLike: false,
      accountEmail: "",
      website: "",
      isLoginFromVision: false,
      addressId: 0,
      originalContactPictureFile: "",
      originalLogoOfCompany: "",
      contactIdEncrypt: "",
      comments: "",
      companyId: 0,
      contactFunction: "",
      contactId: 0,
      createdOn: "",
      emailId: "",
      errorMessage: "",
      facebook: "",
      firstName: "",
      incotermId: 0,
      industry: "",
      industryId: 0,
      isActive: true,
      isAdmin: true,
      isBuyer: false,
      isMailInHtml: true,
      isNotifyByEmail: true,
      languageId: 0,
      lastName: "",
      linkedIn: "",
      modifiedOn: "",
      password: "",
      phoneNo: "",
      recordOriginId: 0,
      result: true,
      roleId: 0,
      showDeltailedRating: true,
      showRfqAwardStat: true,
      title: "",
      tweeter: "",
      userId: "",
      contactPictureFile: "",
      logoOfCompany: "",
      token: "",
      language: null,
      address: this.iAddressModel,
      company: this.iCompanyModel,
      isVarified: false,
      expiration: null,
      currentPassword: "",
      newPassword: "",
      isRFQCreated: false,
      grantType: "",
      refreshToken: "",
      googleImageUrl: "",
      isCapabilitiesFilled: false,
      isCompanyProfileFilled: false,
      npsScore: 0,
      currentUserRole: [],
      noOfStars: 0,
      isVisionUserRequest: false,
      instagram: "",
    };
  }

  isLoginFieldValid(field: string) {
    return this.customValidatorsService.isFieldValid(
      this.registerSupplierForm,
      field
    );
  }
  checkOnClose() {
    if (this.isCountryMultiSelectTouched) {
      if (this.iContactViewModel1.address.countryId === 0) {
        this.errorOnCountryMultiSelect = true;
      } else {
        this.errorOnCountryMultiSelect = false;
      }
    }
    if (this.labelFocus === "sCountryId") {
      this.setFocus("no");
    }
  }

  setFocus(flag: string) {
    this.labelFocus = flag;
  }
  getCountry() {
    this.masterService.getCountry().subscribe(
      (data2: ICountryViewModel[]) => {
        this.iCountryColl = data2;
      },
      (error) => () => {
        this.rfqService.handleError(error);
      }
    );
  }

  applicableRole() {
    if (this.applicableRoles) {
      for (let index = 0; index < this.applicableRoles.length; index++) {
        if (this.applicableRoles[index] === "Seller") {
          this.buyerSupplier = true;
        } else if (this.applicableRoles[index] === "Buyer") {
          this.SupplierBuyer = true;
        }
      }
    }
  }
  getNotification(messageId) {
    this.messageService.GetNotifications().subscribe(
      (data: any) => {
        if (data["result"]) {
          if (data.data !== null && data.data.length > 0) {
            this.iMessageHubModelList = data.data.slice(0, 10);
            if (messageId !== "") {
              this.rfqService.set(false, "showSidePanel");
              AppStorageUtil.removeItem("Rfqdetails");
              this.rfqService.set(null, "partList");
              this.rfqService.set(null, "getManufacturesByRfqData");
              this.rfqService.set(null, "GetSupplierRFQQuoteDetailsData");
              this.detailRfq(messageId);
            }
          }
          this.isNotificationLoader = false;
        } else {
          this.isNotificationLoader = false;
        }
      },
      (error) => () => {
        this.isNotificationLoader = false;
        this.rfqService.handleError(error);
      }
    );
  }

  closeModel(event) {
    this.showSessionModel = event;
  }
  // isRFQCreated: boolean = false;
  async getIpAddress() {
    this.ipAddress = await this.ipService.getIp();
  }
  getAppVersionNumber(){
    return AppStorageUtil.getItem("appVersion");
  }
  currentVersionInfo: VersionInfo;
  hasPendingUpdate: boolean = false;
  shouldShowVersion: boolean = false;
  oldVersion: string;
  private queryParamsSubscription: Subscription;
  isOldDashboard: boolean = true;
  ngOnInit() {

    if(this.userType === "Supplier" &&
      (this.userLocation === "US" || this.userLocation === "Canada")){
      this.isOldDashboard = false;
      }
    this.refreshSupplierNetworkMyBuyersMenu();
      this.routerEventsSubscription = this.router.events.subscribe(event=>{
    if(event instanceof NavigationEnd){
      this.currentRoute = event.urlAfterRedirects || event.url;
      this.syncHideAppChromeFromRoute();
      // Auto-expand parent menu if any child is active
      if (this.leftMenu) {
        this.setActiveMenuExpanded();
      }
      if(this.versionUpdateDetected){
        console.log('NavigationEnd', event);
        this.reloadApp();
      }
    }
   })
   // Initialize current route
   this.currentRoute = this.router.url;
    this.syncHideAppChromeFromRoute();
    this.getIpAddress();
    this.accountType = AppStorageUtil.getItem("AccountType");
    this.checkScheduleDemoStatus();


    // Check URL parameters for showVersion (optional override)
    this.queryParamsSubscription = this.activatedRoute.queryParams.subscribe(params => {
      // If showVersion parameter is explicitly set, use it; otherwise keep default true
      if (params['showVersion'] !== undefined) {
        this.shouldShowVersion = params['showVersion'] === 'true';
      }
      // Default behavior: shouldShowVersion remains true for automatic notifications
    });

    // Create event listener function
    this.versionUpdateListener = (event: any) => {
      // Validate event.detail exists before accessing versionInfo
      if (!event || !event.detail || !event.detail.versionInfo) {
        console.warn('Invalid versionUpdate event received:', event);
        return;
      }

      // Run within Angular zone to ensure change detection
      this.ngZone.run(() => {
        this.oldVersion = AppStorageUtil.getItem("appVersion");
        this.hasPendingUpdate = true;
        this.currentVersionInfo = event.detail.versionInfo;
        this.versionUpdateDetected = true;
        console.log('Version update detected:', this.currentVersionInfo);
      });
    };

    // Add event listener
    window.addEventListener('versionUpdate', this.versionUpdateListener);

    this.profileService.getLeftMenuItems().subscribe(data=>{
      if(data.status){
      this.leftMenu = this.normalizeBuyerLeftMenu(data.menuDetails);
      this.isProfessionalPackage = data.isProfessionalPackage;
      AppStorageUtil.setItem("isProfessionalPackage", this.isProfessionalPackage);

      if (this.userType === 'Supplier') {
        if (this.userLocation === 'US' || this.userLocation === 'Canada') {
          this.logoDetail.routerLink = "/dashboard/supplier/";
        } else {
          this.logoDetail.routerLink = "/dashboard/supplier/ecommerce/";
        }
      }

      if (this.userType === 'Buyer') {
        this.profileService.getConfigCatBuyerAiData().subscribe(isBuyerAiEnabled => {
          if (this.leftMenu) {
            this.leftMenu = this.leftMenu.map(item => {
              if (item.hasChildren && item.children) {
                if (isBuyerAiEnabled) {
                  // Flag ON: remove standalone "(AI) Create RFQ", redirect "Create an RFQ" → rfq-ai route;
                  // remove separate "draftrfqs-ai" nav — /rfq/draftrfqs serves AI drafts (legacy via ?legacy=true)
                  const children = item.children
                    .filter((child: any) => child.state !== 'rfq-ai' && child.state !== 'draftrfqs-ai')
                    .map((child: any) =>
                      child.state === 'buyer' ? { ...child, state: 'rfq-ai' } : child
                    );
                  return { ...item, children };
                } else {
                  // Flag OFF: remove rfq-ai and draftrfqs-ai items entirely
                  return { ...item, children: item.children.filter((child: any) =>
                    child.state !== 'rfq-ai' && child.state !== 'draftrfqs-ai'
                  )};
                }
              }
              return item;
            });
          }
        });
      }

      const logoDetail=data.logoDetail;
      this.logoDetail.initials=logoDetail.initials;
      this.logoDetail.companyFullName=logoDetail.companyFullName;
      this.logoDetail.imgSrc=logoDetail.imgSrc;
      this.logoDetail.ready = true;

      // Auto-expand parent menu if any child is active
      this.setActiveMenuExpanded();
    }
      this.sidebarMenuLoading = false;
     },
     () => {
      this.sidebarMenuLoading = false;
     });

    this.checkTileAvailability();

    if (this.isVisionUser !== "true") {
      this.showTermsAndConditionModal();
    }
    setInterval(() => {
      let isOpend = AppStorageUtil.getItem("abc");
      this.subscribeRef = this.sessionExpireService
        .sessionExpireAlert()
        .subscribe((res) => {
          if (res && isOpend != "true") {
            this.showSessionModel = false;
            setTimeout(() => {
              this.showSessionModel = true;
            }, 30000);
          }
        });
    }, 60000);
    this.getNewIconStatus();
    this.setBackgroundPattern("pattern1");
    this.getNotification("");
    this.isAdmin();

    this.modalSubscription = this.profileService
      .getShowBilling()
      .subscribe((response) => {
        AppStorageUtil.removeItem("isSubscription");
        if (response) {
          this.toShowBillingMenu = true;
          this.profileService.setShowBilling(false);
        }
      });
    this.getBillingMenuInfo();
    if (this.userType === 'Buyer') {
      this.getLicensesMenuInfo();
    }
    this.getEmailVerificationStatus();
    this.checkUserLocation();
    setTimeout(() => {
      this.newMessageCount = JSON.parse(
        AppStorageUtil.getItem("newMessageCount")
      );
      this.newNotifications = JSON.parse(
        AppStorageUtil.getItem("newNotifications")
      );
    }, 3000);
    this.startRFQCountPolling();
    this.initializeTalkJSUnreadTracking();
    this.buyerAiLeftNavUnlockCheckSub = this.profileService
      .getBuyerAiLeftNavUnlockCheckRequests()
      .subscribe(() => {
        this.buyerAiLeftNavUnlockPollAttempt = 0;
        this.checkBuyerAiLeftNavUnlockHintOnce();
        this.getSubmittedRFQCount();
      });

  }

  startRFQCountPolling() {
    // Initial call
    this.getUnseenPrivateRFQCount();

    // Set up polling every 2 minutes
    this.rfqCountSubscription = interval(120000).subscribe(() => {
      this.getUnseenPrivateRFQCount();
    });
  }

  initializeTalkJSUnreadTracking() {
    // Initialize TalkJS session for unread message tracking
    this.talkjsService.initializeSessionForUnreadTracking().then(() => {
      // Subscribe to unread count changes
      this.talkjsService.unreadCount$.subscribe((count) => {
        this.ngZone.run(() => {
          this.unreadChatCount = count;
          // Update the Chat menu item badge
          if (this.leftMenu) {
            const chatMenuItem = this.leftMenu.find(item => item.state === 'chat');
            if (chatMenuItem) {
              chatMenuItem.badge = count > 0 ? count.toString() : null;
            }
          }
        });
      });
    }).catch((error) => {
      console.error('Failed to initialize TalkJS unread tracking:', error);
    });
  }

  get displayedLeftMenu(): any[] {
    if (this.sidebarMenuLoading) {
      return this.sidebarSkeletonMenu;
    }
    return this.leftMenu || [];
  }

  getUnseenPrivateRFQCount() {
    this.rfqService.getUnseenPrivateRFQCount(this.loggedCompanyId).subscribe(
      response => {
        if (response && response.count !== undefined) {
          this.showBubble = response.count > 0;
        } else {
          this.showBubble = false;
        }
      },
      error => {
        console.error(error);
        this.showBubble = false;
      }
    );
  }

  showTermsAndConditionModal() {
    let email = AppStorageUtil.getItem("User2");
    if (
      AppUtil.isNotEmptyString(email) &&
      AppUtil.isNotEmptyString(this.loggedId)
    ) {
      this.rfqService.GetTermsAndConditions(email, this.loggedId).subscribe(
        (result) => {
          let isTermsModelShow = false;
          if (result.data.isAcceptance === null) {
            this.rfqService.set(true, "isTermsModelShow");
            isTermsModelShow = true;
          }
          this.rfqService.set(isTermsModelShow, "isTermsModelShow");
        },
        (error) => {
          this.isLoader = false;
          this.rfqService.handleError(error);
        },

        () => { }

      );
    }
  }

  isTermsModelShow() {
    return this.rfqService.get("isTermsModelShow");
  }

  getEmailVerificationStatus() {
    this.userType = AppStorageUtil.getItem("Usertype");
    if (this.userType === "Buyer") {
      if (this.loggedId !== null && this.loggedId !== undefined) {
        this.masterService
          .getEmailVerificationStatus(this.loggedId)
          .subscribe((response) => {
            if (!response.isError) {
              AppStorageUtil.setItem("isEmailVerify", "" + response.data);
            }
          });
      }
    }
  }
  getNewIconStatus() {
    this.supplierService
      .getNewIconStatus(this.loggedCompanyId)
      .subscribe((response) => {
        if (!response.isError && response.data) {
          this.toShowNewIcon = response.data;
        }
      });
  }
  setShowNewIcon(urlName) {
    if (this.toShowNewIcon == true && urlName === "Magic Lead List") {
      this.supplierService
        .setNewIconStatus(this.loggedCompanyId)
        .subscribe((response) => {
          if (!response.isError && response.data) {
            this.toShowNewIcon = false;
          }
        });
    }
  }
  getBillingMenuInfo() {
    this.supplierService
      .getSubscriptionPlanExists(this.loggedCompanyId)
      .subscribe((response) => {
        if (!response.isError && response.data) {
          this.toShowBillingMenu = response.data;
        }
      });
  }

  getLicensesMenuInfo(): void {
    if (this.userType !== 'Buyer') {
      this.toShowLicensesMenu = false;
      this.toShowDownloadsMenu = false;
      return;
    }

    this.updateBuyerPlatformMenuVisibility();

    const enc = AppStorageUtil.getItem('LoggedIdEncript');
    if (!enc) {
      return;
    }

    this.profileService.getProfileForLoginDetails(enc).subscribe({
      next: (contact) => this.updateBuyerPlatformMenuVisibility(contact),
      error: () => {
        this.toShowLicensesMenu = false;
        this.toShowDownloadsMenu = false;
      }
    });
  }

  private updateBuyerPlatformMenuVisibility(contact?: IContactViewModel | null): void {
    const resolvedContact = contact ?? this.getStoredContactViewModel();
    this.toShowLicensesMenu = isBuyerPlatformAdmin(resolvedContact);
    this.toShowDownloadsMenu = isBuyerPlatformMember(resolvedContact);
    this.applyBuyerPlatformLeftNavUnlockIfEligible(resolvedContact);
  }

  private applyBuyerPlatformLeftNavUnlockIfEligible(contact?: IContactViewModel | null): void {
    const resolved = contact ?? this.getStoredContactViewModel();
    if (!shouldBypassBuyerLeftNavLock(resolved)) {
      return;
    }
    this.buyerNavUnlockFromPoll = true;
    this.buyerNavUnlockHintLatched = true;
    this.stopBuyerAiLeftNavUnlockPolling();
  }

  private getStoredContactViewModel(): IContactViewModel | null {
    try {
      return JSON.parse(AppStorageUtil.getItem('iContactViewModel') || 'null');
    } catch {
      return null;
    }
  }

  showSupplierBuyer() {
    this.selectedItems = [];
    this.getCountry();
    if (this.userType === "Supplier") {
      this.header = "Create Buyer Account";
    }
    if (this.userType === "Buyer") {
      this.header = "Create Manufacturer Account";
    }
    if (AppUtil.isEmptyString(this.iContactViewModel1.companyId) || this.iContactViewModel1.companyId === 0) {
      this.toastr.error(
        "Please update Company details first from Contact Information section",
        "Error!"
      );
    } else {
      this.getprofile();
      this.createForm();
      this.isSupplier = true;
    }
  }
  hideSupplier() {
    this.isSupplier = false;
  }

  getprofile() {
    if (
      (this.iContactViewModel1.companyId === 0 ||
        this.iContactViewModel1.companyId === null) &&
      (this.iContactViewModel1.company.name === "" ||
        this.iContactViewModel1.company.name === null)
    ) {
      if (this.rfqService.get("CompanyName")) {
        this.iContactViewModel1["company"].name =
          this.rfqService.get("CompanyName");
      }
      if (this.rfqService.get("companyId")) {
        this.iContactViewModel1.companyId = this.rfqService.get("companyId");
      }
    }
  }
  GetProfileDetails() {
    const id = this.loggedId;
    this.userCreatedDateString = "";
    const ContactModelFromLocal = JSON.parse(
      AppStorageUtil.getItem("iContactViewModel")
    );
    if (
      this.loggedEncryptId !== undefined &&
      this.loggedEncryptId !== null &&
      this.loggedEncryptId !== ""
    ) {
      this.profileService
        .getProfileForLoginDetails(this.loggedEncryptId)
        .subscribe((result) => {
          this.iContactViewModel1 = result;
          AppStorageUtil.setItem('iContactViewModel', JSON.stringify(this.iContactViewModel1));
          this.updateBuyerPlatformMenuVisibility(result);
          if (
            !!this.iContactViewModel1.contactPictureFile &&
            this.iContactViewModel1.contactPictureFile !== ""
          ) {
            if (
              AppStorageUtil.getItem("userHeaderLogo") !==
              this.iContactViewModel1.contactPictureFile
            ) {
              AppStorageUtil.setItem(
                "userHeaderLogo",
                this.iContactViewModel1.contactPictureFile
              );
            }
          }
          if (this.iContactViewModel1.contactPictureFile) {
            this.logoPathToShow = this.iContactViewModel1.contactPictureFile;
          }
          AppStorageUtil.setItem("userId", this.iContactViewModel1.userId);
          AppStorageUtil.setItem(
            "iContactViewModel",
            JSON.stringify(this.iContactViewModel1)
          );
          this.getSourcingAdvisor();
          this.createForm();
          this.refreshSupplierNetworkMyBuyersMenu();
        });
    } else {
      AppStorageUtil.clear();
      AppStorageUtil.clearSession();
      this.router.navigate(["auth/login/simple"]);
    }
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    let reSizeFlag = true;
    if (
      this.pcodedDeviceType === "tablet" &&
      this.windowWidth >= 768 &&
      this.windowWidth <= 1024
    ) {
      reSizeFlag = false;
    } else if (this.pcodedDeviceType === "mobile" && this.windowWidth < 768) {
      reSizeFlag = false;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.windowWidth);
    }
  }

  setHeaderAttributes(windowWidth) {
    if (windowWidth < 992) {
      this.navRight = "nav-off";
    } else {
      this.navRight = "nav-on";
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.pcodedDeviceType = "tablet";
      this.verticalNavType = "offcanvas";
      this.verticalEffect = "overlay";
    } else if (windowWidth < 768) {
      this.pcodedDeviceType = "mobile";
      this.verticalNavType = "offcanvas";
      this.verticalEffect = "overlay";
    } else {
      this.pcodedDeviceType = "desktop";
      this.verticalNavType = "expanded";
      this.verticalEffect = "shrink";
    }
  }

  toggleHeaderNavRight() {
    this.navRight = this.navRight === "nav-on" ? "nav-off" : "nav-on";
    this.chatTopPosition = this.chatTopPosition === "nav-on" ? "112px" : "";
    if (this.navRight === "nav-off" && this.innerChatSlideInOut === "in") {
      this.toggleInnerChat();
    }
    if (this.navRight === "nav-off" && this.chatSlideInOut === "in") {
      this.toggleChat();
    }
  }

  toggleLiveNotification() {
    this.liveNotification =
      this.liveNotification === "an-off" ? "an-animate" : "an-off";
    this.liveNotificationClass =
      this.liveNotification === "an-animate" ? "active" : "";
    this.showBell = false;
    this.newNotifications = 0;
    AppStorageUtil.setItem(
      "newNotifications",
      JSON.stringify(this.newNotifications)
    );
    if (
      this.liveNotification === "an-animate" &&
      this.innerChatSlideInOut === "in"
    ) {
      this.toggleInnerChat();
    }
    if (
      this.liveNotification === "an-animate" &&
      this.chatSlideInOut === "in"
    ) {
      this.toggleChat();
    }
  }

  toggleLiveMessages() {
    this.showMessage = false;
    this.newMessageCount = 0;
    AppStorageUtil.setItem(
      "newMessageCount",
      JSON.stringify(this.newMessageCount)
    );
  }

  toggleProfileNotification() {
    this.profileNotification =
      this.profileNotification === "an-off" ? "an-animate" : "an-off";
    this.profileNotificationClass =
      this.profileNotification === "an-animate" ? "active" : "";

    if (
      this.profileNotification === "an-animate" &&
      this.innerChatSlideInOut === "in"
    ) {
      this.toggleInnerChat();
    }
    if (
      this.profileNotification === "an-animate" &&
      this.chatSlideInOut === "in"
    ) {
      this.toggleChat();
    }
  }

  onEmailTextClick(event: MouseEvent) {
    const selectedText = window.getSelection()?.toString().trim();
    if (selectedText) {
      event.stopPropagation();
      return;
    }
    this.toggleProfileNotification();
    event.stopPropagation();
  }

  openHeaderImagePreview(imageSrc: string, event?: MouseEvent) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const eventTarget = event?.target as HTMLImageElement;
    const resolvedSrc = imageSrc || eventTarget?.currentSrc || eventTarget?.src;
    if (!resolvedSrc) {
      return;
    }
    this.headerImagePreviewSrc = resolvedSrc;
  }

  closeHeaderImagePreview() {
    this.headerImagePreviewSrc = null;
  }

  notificationOutsideClick(ele: string) {
    if (ele === "live" && this.liveNotification === "an-animate") {
      this.toggleLiveNotification();
    } else if (ele === "profile" && this.profileNotification === "an-animate") {
      this.toggleProfileNotification();
    }
  }

  toggleChat() {
    this.chatSlideInOut = this.chatSlideInOut === "out" ? "in" : "out";
    if (this.innerChatSlideInOut === "in") {
      this.innerChatSlideInOut = "out";
    }
  }

  toggleInnerChat() {
    this.innerChatSlideInOut =
      this.innerChatSlideInOut === "out" ? "in" : "out";
  }

  searchOn() {
    document.querySelector("#main-search").classList.add("open");
    const searchInterval = setInterval(() => {
      if (this.searchWidth >= 200) {
        clearInterval(searchInterval);
        return false;
      }
      this.searchWidth = this.searchWidth + 15;
      this.searchWidthString = this.searchWidth + "px";
    }, 35);
  }

  searchOff() {
    const searchInterval = setInterval(() => {
      if (this.searchWidth <= 0) {
        document.querySelector("#main-search").classList.remove("open");
        clearInterval(searchInterval);
        return false;
      }
      this.searchWidth = this.searchWidth - 15;
      this.searchWidthString = this.searchWidth + "px";
    }, 35);
  }

  toggleOpened() {
    if (this.windowWidth < 992) {
      this.toggleOn =
        this.verticalNavType === "offcanvas" ? true : this.toggleOn;
      if (this.navRight === "nav-on") {
        this.toggleHeaderNavRight();
      }
    }

    this.verticalNavType = this.verticalNavType === "expanded" ? "offcanvas" : "expanded";
    if (this.verticalNavType === "offcanvas") {
      this.rfqService.set(true, "isSideMenuVisible");
    } else {
      this.rfqService.set(false, "isSideMenuVisible");
    }
  }

  onClickedOutsideSidebar(e: Event) {
    if (
      (this.windowWidth < 992 &&
        this.toggleOn &&
        this.verticalNavType !== "offcanvas") ||
      this.verticalEffect === "overlay"
    ) {
      this.toggleOn = true;
      // commented for responsive sidebar is not coming
      //  this.verticalNavType = 'offcanvas';
    }
  }

  toggleRightbar() {
    this.configOpenRightBar = this.configOpenRightBar === "open" ? "" : "open";
  }

  setNavBarTheme(theme: string) {
    if (theme === "themelight1") {
      this.navBarTheme = "themelight1";
      this.menuTitleTheme = "theme1";
      this.sidebarImg = "false";
    } else {
      this.menuTitleTheme = "theme6";
      this.navBarTheme = "theme1";
      this.sidebarImg = "false";
    }
  }

  setVerticalLayout() {
    this.isVerticalLayoutChecked = !this.isVerticalLayoutChecked;
    if (this.isVerticalLayoutChecked) {
      this.verticalLayout = "box";
      this.displayBoxLayout = "";
    } else {
      this.verticalLayout = "wide";
      this.displayBoxLayout = "d-none";
    }
  }

  setBackgroundPattern(pattern: string) {
    document.querySelector("body").setAttribute("themebg-pattern", pattern);
  }

  setSidebarPosition() {
    this.isSidebarChecked = !this.isSidebarChecked;
    this.pcodedSidebarPosition =
      this.isSidebarChecked === true ? "fixed" : "absolute";
    this.sidebarFixedHeight =
      this.isHeaderChecked === true
        ? "calc(100vh + 56px)"
        : "calc(100vh - 56px)";
  }

  setHeaderPosition() {
    this.isHeaderChecked = !this.isHeaderChecked;
    this.pcodedHeaderPosition =
      this.isHeaderChecked === true ? "fixed" : "relative";
    this.headerFixedMargin = this.isHeaderChecked === true ? "75px" : "";
  }
  isBuyerProfile() {
    const tempType = AppStorageUtil.getItem("Usertype");
    return tempType;
  }

  get headerBrandHomeLink(): string | null {
    return this.logoDetail.ready ? this.logoDetail.routerLink : null;
  }

  get loggedId() {
    // tslint:disable-next-line:radix
    return parseInt(AppStorageUtil.getItem("LoggedId"));
  }
  get loggedEncryptId() {
    // tslint:disaabale-next-line:radix
    return AppStorageUtil.getItem("LoggedIdEncript");
  }
  getSourcingAdvisor() {
    let companyId;
    if (!this.loggedCompanyId) {
      companyId = 0;
    } else {
      companyId = this.loggedCompanyId;
    }
    this.profileService.GetCompanySourcingAdvisor(companyId).subscribe(
      (result) => {
        if (result.result) {
          AppStorageUtil.setItem("iSourcingAdvisorEmail", result.data.email);
          this.iSourcingAdvisorModel = result.data;
          if (
            this.iSourcingAdvisorModel.title == null ||
            this.iSourcingAdvisorModel.title == "" ||
            this.iSourcingAdvisorModel.title == undefined
          ) {
            this.iSourcingAdvisorModel.title = "Customer Support";
          }
          if (
            result.data.userPhone != null &&
            result.data.userPhone != undefined &&
            result.data.userPhone != ""
          ) {
            this.iSourcingAdvisorModel.userPhone =
              result.data.userPhone.replace(/^\++|\++$/g, "");
          }
        } else {
          this.toastr.error("Failed to get Sourcing Advisor", "Error!");
        }
      },
      (error) => {
        this.rfqService.handleError(error);
      },

      () => { }

    );
  }

  shortName(onignalText) {
    const count = 16;
    if (onignalText !== null) {
      if (onignalText.length > count) {
        return onignalText.slice(0, count - 3).concat("...");
      } else {
        return onignalText;
      }
    }
  }

  isAllowd() {
    return this.radio1 === 0;
  }

  GetProfileDetailsForNPSModel(notifyUserID) {
    this.profileService
      .getProfileDetails(notifyUserID, this.loggedId)
      .subscribe(
        (result) => {
          this.iContactViewModelNPSModel = result;
          this.isNPSPupupShow = true;
          this.ratingsPopupLogoPath = "assets/company/avatar-manu-basic.svg";
          if (
            !!this.iContactViewModelNPSModel.contactPictureFile &&
            this.iContactViewModelNPSModel.contactPictureFile !== ""
          ) {
            this.ratingsPopupLogoPath =
              this.defaultAwsPath +
              this.iContactViewModelNPSModel.contactPictureFile;
          }
          if (this.iContactViewModelNPSModel.isBuyer) {
            this.npsRatingPopupTitle = "Rate this Buyer";
          } else {
            this.npsRatingPopupTitle = "Rate this Manufacturer";
          }
        },
        (error) => {
          this.rfqService.handleError(error);
        },

        () => { }

      );
  }

  closeNPSPopup() {
    this.iRatingResponseViewModel.isNotNowClicked = true;
    this.iRatingResponseViewModel.score = "";
    this.iRatingResponseViewModel.fromId = this.fromContactOfMessage;
    this.iRatingResponseViewModel.toId = this.toContactOfMessage;
    this.submitResponse();
  }
  submitRating() {
    this.iRatingResponseViewModel.score = "" + this.radio1;
    this.iRatingResponseViewModel.isNotNowClicked = false;
    if (this.loggedId === this.fromContactOfMessage) {
      this.iRatingResponseViewModel.fromId = this.fromContactOfMessage;
      this.iRatingResponseViewModel.toId = this.toContactOfMessage;
    } else if (this.loggedId === this.toContactOfMessage) {
      this.iRatingResponseViewModel.fromId = this.toContactOfMessage;
      this.iRatingResponseViewModel.toId = this.fromContactOfMessage;
    }
    this.submitResponse();
  }

  submitResponse() {
    this.supplierService
      .AddNPSResponse(this.iRatingResponseViewModel)
      .subscribe(
        (result) => {
          if (result.result === true) {
            AppStorageUtil.setSessionItem("isGlobalMsgRaiting", "true");
            if (this.iRatingResponseViewModel.score === "") {
              this.isNPSPupupShow = false;
              this.radio1 = 0;
              this.resetNPSModuleModel();
              this.getNotification("");
            } else {
              this.toastr.success(result.errorMessage, "Success!");
              this.isNPSPupupShow = false;
              this.radio1 = 0;
              this.resetNPSModuleModel();
              this.getNotification("");
            }
          } else {
            this.toastr.error(result.errorMessage, "Error!");
          }
        },
        (error) => {
          this.rfqService.handleError(error);
        },

        () => { }

      );
  }

  logoPathReload() {
    const tempPath = AppStorageUtil.getItem("userHeaderLogo");
    if (!!tempPath && tempPath.length) {
      if (this.currentlogoPath !== tempPath) {
        this.currentlogoPath = tempPath;
        this.logoPathToShow = this.defaultAwsPath + tempPath;
      }
    }

    if (!this.logoPathToShow || this.logoPathToShow === "") {
      this.logoPathToShow = "";
    }
  }
  checkAccountUpgradeReqSent() {
    const tempFlag = this.supplierService.get("accountUpgradeReqFlag");
    if (tempFlag === true) {
      this.isAccountUpgradeReqSent = true;
      this.accountUpgradeMessage = this.supplierService.get(
        "accountUpgradeReqMessage"
      );
      this.supplierService.set(false, "accountUpgradeReqFlag");
      this.supplierService.set("", "accountUpgradeReqMessage");
    }
  }
  closeAccountUpgradePopUp() {
    this.isAccountUpgradeReqSent = false;
    this.isAccountUpgradereqSent = false;
  }

  detailRfq(msgHubmodel: IMessageHubModel) {
    if (
      msgHubmodel.rfqId !== undefined &&
      msgHubmodel.rfqId !== null &&
      msgHubmodel.rfqId !== 0 &&
      msgHubmodel.messageTypeId !== 210 &&
      msgHubmodel.messageTypeId !== 211 &&
      msgHubmodel.messageTypeId !== 226
    ) {
      let currentDetailsId = AppStorageUtil.getItem("detailRfqId");
      if (this.userType === "Buyer") {
        currentDetailsId = AppStorageUtil.getItem("detailRfqId");
      } else {
        currentDetailsId = AppStorageUtil.getItem("supplierRfqDetailId");
      }
      const currentMessageType = AppStorageUtil.getItem("currentMessageType");
      if (
        currentMessageType !== msgHubmodel.messageType ||
        currentDetailsId !== msgHubmodel.rfqId.toString()
      ) {
        AppStorageUtil.setItem("currentMessageType", msgHubmodel.messageType);
        const encryptedRfqID = this.profileService.encrypt(msgHubmodel.rfqId);
        this.rfqService.set(true, "isFromNotification");
        switch (msgHubmodel.messageType) {
          case "RFQ_RELEASED_BY_ENGINEERING":
          case "RFQ_BUYER_INVITATION":
          case "RFQ_EDITED_RESUBMIT_QUOTE": {
            break;
          }
          case "rfqResponse":
          case "rfqFreeMessage":
          case "RFQ_LIKED_BY_SUPPLIER":
          case "RFQ_DISLIKED_BY_SUPPLIER":
          case "BUYER_FOLLOW_SUPPLIER":
          case "BUYER_VIEW_SUPPLIER_PROFILE":
          case "SUPPLIER_VIEW_BUYER_PROFILE": {
            AppStorageUtil.setItem("msgTab", "true");
            AppStorageUtil.setItem(
              "msgTabMessageDrawer",
              JSON.stringify(msgHubmodel)
            );
            break;
          }
          case "rfqConfirmationMessage":
          case "rfqNonConfirmationMessage": {
            AppStorageUtil.setItem("quotesTab", "true");
            break;
          }
          case "MESSAGE_TYPE_CONFIDENTIALITY_AGREEMENT": {
            AppStorageUtil.setItem("ndaTab", "true");
            break;
          }
          default: {
            break;
          }
        }
        if (
          !(
            msgHubmodel.messageType === "SUPPLIER_NPS_RATING" ||
            msgHubmodel.messageType === "BUYER_NPS_RATING"
          )
        ) {
          if (this.userType === "Buyer") {
            this.router.navigate(["/rfq/rfqdetail"], {
              queryParams: {
                rfqId: encryptedRfqID,
              },
            });
          } else {
            AppStorageUtil.setItem("isFromNotification", "yes");
            AppStorageUtil.setItem("isNotificationPage", "true");
            this.router.navigate(["/supplier/supplierRfqDetails"], {
              queryParams: {
                rfqId: "" + encryptedRfqID,
              },
            });
          }
        }
      }
    } else {
      // 156 === SUPPLIER_NPS_RATING
      // 157 === BUYER_NPS_RATING
      if (
        msgHubmodel.messageType === "SUPPLIER_NPS_RATING" ||
        msgHubmodel.messageType === "BUYER_NPS_RATING"
      ) {
        this.workOnNPSPopup(msgHubmodel);
      } else if (
        msgHubmodel.messageType === "rfqFreeMessage" ||
        (msgHubmodel.messageType === "QUOTED_MARKED_QUOTED_RFQ_EDITED" &&
          msgHubmodel.isNotification === false)
      ) {
        this.router.navigate(["/globalMessage"]);
      } else if (msgHubmodel.isNotification === true) {
        this.router.navigate(["/globalNotification"]);
      }
    }
  }

  markRead(messageId) {
    this.rfqService
      .changeMessageStatus(messageId.messageId)
      .subscribe((result) => {
        this.getNotification(messageId);
      });
  }
  isNPSPopupReqFromMessageTab() {
    if (this.rfqService.get("isNPSPopupReqFromMessageTab") === true) {
      this.rfqService.set(false, "isNPSPopupReqFromMessageTab");
      const tempNPSObj = this.rfqService.get("NPSPopupReqModelFromMessageTab");
      this.workOnNPSPopup(tempNPSObj);
    }
  }
  workOnNPSPopup(msgHubmodel) {
    this.resetNPSModuleModel();
    this.isNPSPupupShow = false;
    this.radio1 = 0;
    this.fromContactOfMessage = msgHubmodel.fromId;
    this.toContactOfMessage = msgHubmodel.toId;
    this.iRatingResponseViewModel.messageId = msgHubmodel.messageId;
    this.iRatingResponseViewModel.contactName =
      this.iContactViewModel1.firstName +
      " " +
      this.iContactViewModel1.lastName;
    if (this.loggedId === msgHubmodel.toId) {
      this.GetProfileDetailsForNPSModel(msgHubmodel.fromContactIdEncrypt);
    } else {
      this.GetProfileDetailsForNPSModel(msgHubmodel.toContactIdEncrypt);
    }
  }
  upgradeClick() {
    this.isUpgradeBtn = true;
    // this.setSupplierUpgraderequest();
  }
  openSaleModel() {
    this.toShowContactModel = true;
    this.showUpgradeAccountModal = false;
  }
  /* This function is called when click on Upgrade to quote button to open the modal */
  upgradeClickModel(isQuotingRfq) {
    this.isQuoteRfq = isQuotingRfq;
    this.showUpgradeAccountModal = true;
  }
  /* This function is used to close the Upgrade Account Modal */
  closeModal(e) {
    this.showUpgradeAccountModal = false;
  }
  setSupplierUpgraderequest() {
    this.iMyAccountViewModel.contactId = this.loggedId;
    this.iMyAccountViewModel.companyId = this.loggedCompanyId;
    if (this.isUpgradeBtn) {
      this.iMyAccountViewModel.istrail = false;
    }
    this.supplierService
      .setSupplierUpgraderequest(this.iMyAccountViewModel)
      .subscribe(
        (result) => {
          this.isLoader = false;
          if (result["result"] === true) {
            if (this.isUpgradeBtn) {
              this.iMyAccountViewModel = result.data;
              this.isUpgradeBtn = false;
              this.accountUpgradereqMessage =
                this.iMyAccountViewModel.errorMessage;
              this.isAccountUpgradereqSent = true;
            }
          } else {
            this.accountUpgradereqMessage = result["errorMessage"];
            this.isAccountUpgradereqSent = true;
          }
        },
        (error) => {
          this.isLoader = false;
          this.accountUpgradereqMessage = "You are already a premium member";
          this.isAccountUpgradereqSent = true;
        },

        () => { }

      );
  }

  viewAll() {
    this.rfqService.set(false, "isBuyerCommpleteProfile");
    this.rfqService.set(false, "messageThreadDrawer");
    this.rfqService.set(false, "showSidePanel");
    this.router.navigateByUrl("/globalNotification");
  }
  isAdmin() {
    this.applicableRoles = JSON.parse(AppStorageUtil.getItem("applicableRoles"));
    if (this.applicableRoles) {
      for (let index = 0; index < this.applicableRoles.length; index++) {
        if (
          this.applicableRoles[index] === "Seller Admin" ||
          this.applicableRoles[index] === "Buyer Admin" ||
          this.applicableRoles[index] === "SellerAdmin" ||
          this.applicableRoles[index] === "BuyerAdmin"
        ) {
          this.isAdminUser = true;
          break;
        }
      }
    }
  }
  checkCompany() {
    if (
      this.loggedCompanyId !== 0 &&
      this.loggedCompanyId !== null &&
      this.loggedCompanyId !== undefined
    ) {
      this.router.navigate(["/profile/user-management/"]);
    } else {
      this.toastr.warning(
        "Please update Company details first from the Profile page",
        "Warning!"
      );
    }
  }
  isPremium() {
    let IsPremiumEncrypt = AppStorageUtil.getItem("IsPremium");
    let IsPremiumDecrypt = this.profileService.decrypt(IsPremiumEncrypt);
    if (IsPremiumDecrypt !== "true" && IsPremiumDecrypt !== "false") {
      AppStorageUtil.clear();
      this.router.navigate(["auth/login/simple"]);
      return;
    }
    if (IsPremiumDecrypt === "true") {
      return true;
    } else {
      return false;
    }
  }
  onPaste(event) {
    let number = event.target.value;
    if (number != undefined && number != null && number != "") {
      // this.iProfileViewModel['phoneNo'] = number.replace(/-/g, '');
      this.registerSupplierForm.patchValue({
        sPhoneNo: number.replace(/-/g, ""),
      });
    }
  }
  ngOnDestroy() {
    if (this.subscribeRef != undefined) {
      this.subscribeRef.unsubscribe();
    }
    if (this.modalSubscription != undefined) {
      this.modalSubscription.unsubscribe();
    }

    AppStorageUtil.removeItem("isSubscription");
    if (this.rfqCountSubscription) {
      this.rfqCountSubscription.unsubscribe();
    }

    // Unsubscribe from router events subscription
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }

    if (this.versionUpdateListener) {
      window.removeEventListener('versionUpdate', this.versionUpdateListener);
    }

    // Unsubscribe from queryParams to prevent memory leak
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }

    if (this.buyerAiLeftNavUnlockPollSub) {
      this.buyerAiLeftNavUnlockPollSub.unsubscribe();
    }
    if (this.buyerAiLeftNavUnlockCheckSub) {
      this.buyerAiLeftNavUnlockCheckSub.unsubscribe();
    }
  }
  closeNotification(e, messageId) {
    this.liveNotification = "an-off";
    this.isNotificationLoader = true;
    this.messageService.CloseBroadcastNotification(messageId).subscribe(
      (res) => {
        if (res["isError"] == false) {
          this.isNotificationLoader = false;
          this.getNotification("");
        } else {
          this.isNotificationLoader = false;
        }
      },
      (error) => {
        this.isNotificationLoader = false;
      }
    );

    e.preventDefault();
  }

  deletedMsgReloadNotification() {
    if (AppStorageUtil.getSessionItem("isGlbMsgDelete") == "true") {
      AppStorageUtil.removeSessionItem("isGlbMsgDelete");
      this.getNotification("");
    }
  }

  checkUserLocation() {
    const accountType = AppStorageUtil.getItem("AccountType");
    this.userLocation = AppStorageUtil.getItem("manufacturingLocation");
    if (
      this.userLocation === "US" ||
      this.userLocation === "Canada" ||
      this.userLocation === "USA & Canada" ||
      this.userLocation === "Mexico"
    ) {
      if (accountType != "Basic") {
        this.toShowLeftImg = true;
        this.sidebarFixedHeight =
          this.isBuyerProfile() === "Supplier" &&
            this.isPaidContract !== "true"
            ? "calc(100vh - 190px)"
            : this.isBuyerProfile() === "Buyer" ||
              (this.isBuyerProfile() === "Supplier" &&
                this.isPaidContract === "true")

              ? "calc(100vh - 160px)"
              : "calc(100vh - 56px)";

      } else {
        this.toShowLeftImg = false;
        this.sidebarFixedHeight =
          this.isBuyerProfile() === "Supplier" &&
            this.isPaidContract !== "true"
            ? "calc(100vh - 190px)"
            : this.isBuyerProfile() === "Buyer" ||
              (this.isBuyerProfile() === "Supplier" &&
                this.isPaidContract === "true")
              ? "calc(100vh - 195px)"
              : "calc(100vh - 56px)";
      }
    } else {

      this.toShowLeftImg = false;
      this.sidebarFixedHeight =
        this.isBuyerProfile() === "Supplier" && this.isPaidContract !== "true"
          ? "calc(100vh - 220px)"
          : this.isBuyerProfile() === "Buyer" ||
            (this.isBuyerProfile() === "Supplier" &&
              this.isPaidContract === "true")

            ? "calc(100vh - 195px)"
            : "calc(100vh - 56px)";
    }
  }

  utcDate(date) {
    return moment.utc(date).toDate();
  }

  reloadAdminCompforSupplier(event) {
    this.router.navigate(["/supplier/profile"]);
  }
  reloadApp(): void {
    console.log('Reloading application due to version update');
    this.versionUpdateDetected=false;
    // Set the new version in storage before reload
    if (this.currentVersionInfo) {
      AppStorageUtil.setItem("appVersion", this.currentVersionInfo.appVersionNumber.toString());
      AppStorageUtil.setItem("buildTime", this.currentVersionInfo.appReleaseDate.toString());
    }

    // Force a full page reload
    window.location.href = window.location.href;
    window.location.reload(); // Force reload from server
  }
  reloadAdminCompforBuyer(event) {
    this.router.navigate(["/profile/buyerprofile"]);
  }
  reloadDashBoardCompforBuyer(event) {
    const path = "/dashboard/buyer/default/";
    this.router.navigateByUrl("", { skipLocationChange: true }).then(() => {
      this.router.navigate([path]);
    });
  }

  submitRfqCount: number = 0;
  /** Session latch: after nav is treated as unlocked, never poll hint API again. */
  buyerNavUnlockHintLatched = false;
  /** True when mp_rfq or mp_widget_drafts exists but GetSubmittedRFQCount still reports 0 (e.g. new widget draft). */
  buyerNavUnlockFromPoll = false;
  private static readonly BUYER_AI_LEFT_NAV_UNLOCK_POLL_INTERVAL_MS = 60000;
  private static readonly BUYER_AI_LEFT_NAV_UNLOCK_POLL_MAX_ATTEMPTS = 20;
  private buyerAiLeftNavUnlockPollAttempt = 0;
  private buyerAiLeftNavUnlockPollSub: Subscription = null;
  private buyerAiLeftNavUnlockCheckSub: Subscription = null;

  get buyerLeftNavLocked(): boolean {
    if (this.userType !== "Buyer") {
      return false;
    }
    if (shouldBypassBuyerLeftNavLock(this.iContactViewModel1 ?? this.getStoredContactViewModel())) {
      return false;
    }
    return this.submitRfqCount === 0 && !this.buyerNavUnlockFromPoll;
  }

  private stopBuyerAiLeftNavUnlockPolling(): void {
    if (this.buyerAiLeftNavUnlockPollSub) {
      this.buyerAiLeftNavUnlockPollSub.unsubscribe();
      this.buyerAiLeftNavUnlockPollSub = null;
    }
  }

  private applyBuyerAiLeftNavUnlockHintResponse(res: any): void {
    const ok = res && (res.result === true || res.Result === true);
    const data = res && (res.data || res.Data);
    const unlock = data && (data.unlock === true || data.Unlock === true);
    if (this.buyerNavUnlockHintLatched) {
      return;
    }
    if (ok && unlock) {
      this.ngZone.run(() => {
        this.buyerNavUnlockFromPoll = true;
        this.buyerNavUnlockHintLatched = true;
        this.stopBuyerAiLeftNavUnlockPolling();
      });
    }
  }

  private checkBuyerAiLeftNavUnlockHintOnce(): void {
    if (this.buyerNavUnlockHintLatched) {
      return;
    }
    if (this.userType !== 'Buyer') {
      return;
    }
    if (shouldBypassBuyerLeftNavLock(this.iContactViewModel1 ?? this.getStoredContactViewModel())) {
      this.applyBuyerPlatformLeftNavUnlockIfEligible();
      return;
    }
    if (this.submitRfqCount > 0) {
      this.buyerNavUnlockHintLatched = true;
      this.stopBuyerAiLeftNavUnlockPolling();
      return;
    }
    const cid = this.loggedId;
    if (!cid || isNaN(cid as any) || cid <= 0) {
      return;
    }
    this.profileService.getBuyerAiLeftNavUnlockHint(cid).subscribe(
      (res) => this.applyBuyerAiLeftNavUnlockHintResponse(res),
      () => {}
    );
  }

  /**
   * buyer_experience_ai only: while left nav is locked (submitRfqCount === 0), poll for mp_rfq / mp_widget_drafts.
   * Stops forever once latched unlocked.
   */
  private maybeStartBuyerAiLeftNavUnlockPolling(): void {
    if (this.buyerNavUnlockHintLatched) {
      return;
    }
    if (this.userType !== "Buyer") {
      return;
    }
    if (shouldBypassBuyerLeftNavLock(this.iContactViewModel1 ?? this.getStoredContactViewModel())) {
      this.applyBuyerPlatformLeftNavUnlockIfEligible();
      return;
    }
    if (this.submitRfqCount > 0) {
      this.buyerNavUnlockHintLatched = true;
      return;
    }
    this.profileService.getConfigCatBuyerAiData().subscribe((isAi) => {
      if (this.buyerNavUnlockHintLatched) {
        return;
      }
      if (!isAi) {
        return;
      }
      if (this.userType !== "Buyer" || this.submitRfqCount > 0) {
        this.buyerNavUnlockHintLatched = true;
        this.stopBuyerAiLeftNavUnlockPolling();
        return;
      }
      this.startBuyerAiLeftNavUnlockPolling();
    });
  }

  private startBuyerAiLeftNavUnlockPolling(): void {
    if (this.buyerAiLeftNavUnlockPollSub) {
      return;
    }
    this.buyerAiLeftNavUnlockPollAttempt = 0;
    this.buyerAiLeftNavUnlockPollSub = timer(
      0,
      AdminComponent.BUYER_AI_LEFT_NAV_UNLOCK_POLL_INTERVAL_MS
    ).subscribe(() => {
      if (this.buyerNavUnlockHintLatched) {
        this.stopBuyerAiLeftNavUnlockPolling();
        return;
      }
      if (this.userType !== "Buyer") {
        this.stopBuyerAiLeftNavUnlockPolling();
        return;
      }
      if (this.submitRfqCount > 0) {
        this.buyerNavUnlockHintLatched = true;
        this.stopBuyerAiLeftNavUnlockPolling();
        return;
      }

      this.buyerAiLeftNavUnlockPollAttempt++;
      if (
        this.buyerAiLeftNavUnlockPollAttempt >
        AdminComponent.BUYER_AI_LEFT_NAV_UNLOCK_POLL_MAX_ATTEMPTS
      ) {
        this.buyerNavUnlockHintLatched = true;
        this.stopBuyerAiLeftNavUnlockPolling();
        return;
      }

      this.checkBuyerAiLeftNavUnlockHintOnce();
    });
  }

  //code written for M2-4416-sprint 7.4 -AJ-(24-05-2022)
  getSubmittedRFQCount() {
    let rfqId = parseInt(AppStorageUtil.getItem("firstRFQId"));
    let checkRFQid;
    if (isNaN(rfqId)) {
      checkRFQid = 0;
    } else {
      checkRFQid = rfqId;
    }
    this.profileService
      .GetSubmittedRFQCount(this.loggedId, checkRFQid)
      .subscribe(
        (result) => {
          if (result.result == true) {
            this.willDoLaterCount = result.data.willDoLaterCount;
            this.submitRfqCount = result.data.rfqCount;
            AppStorageUtil.setItem("willDoLater", result.data.willDoLaterCount);
            AppStorageUtil.setItem("submitRfqCount", result.data.rfqCount);
            this.applyBuyerPlatformLeftNavUnlockIfEligible();
            if (this.submitRfqCount > 0) {
              this.buyerNavUnlockHintLatched = true;
              this.stopBuyerAiLeftNavUnlockPolling();
            } else {
              this.maybeStartBuyerAiLeftNavUnlockPolling();
            }
            if (this.isGetSubmited) {
              this.isreloadDashboardComp();
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  isreloadDashboardComp() {
    const willDoLaterPath = parseInt(AppStorageUtil.getItem("willDoLater"), 10);
    const submitRfqCount = parseInt(
      AppStorageUtil.getItem("submitRfqCount"),
      10
    );
    const buyerDash = "dashboard/buyer/default";

    if (willDoLaterPath === 0 && submitRfqCount === 0) {
      // Keep new buyers on the dashboard so the onboarding popup can show before RFQ creation.
      this.router.navigateByUrl("", { skipLocationChange: true }).then(() => {
        this.router.navigate([buyerDash]);
      });
    } else if (willDoLaterPath === 0 && submitRfqCount >= 1) {
      this.router.navigateByUrl("", { skipLocationChange: true }).then(() => {
        this.router.navigate([buyerDash]);
      });
    } else if (willDoLaterPath === 1 && submitRfqCount >= 1) {
      this.router.navigateByUrl("", { skipLocationChange: true }).then(() => {
        this.router.navigate([buyerDash]);
      });
    } else if (willDoLaterPath === 1 && submitRfqCount === 0) {
      this.router.navigateByUrl("", { skipLocationChange: true }).then(() => {
        this.router.navigate([buyerDash]);
      });
    }
  }


  checkTileAvailability() {
    const contactId = this.loggedId;
    const companyId = this.loggedCompanyId;
    //config cat is started


    //config cat is ended
    this.supplierService.getTileAvailability(contactId, companyId).subscribe(
      (result) => {
        if (result.length > 0) {
          let firstResult = result[0];

          this.showMfgContactRfqsLeftMenu = firstResult.showMfgContactRfqsLeftMenu;
          this.unlockedRfq = firstResult.totalUnlockRfqCount;
        let inputData = {
          userType: this.userType,
          accountType: this.accountType,
          userLocation: this.userLocation,
          showMfgContactRfqLeftMenu: this.showMfgContactRfqsLeftMenu,
          unlockedRfq: this.unlockedRfq
        }
          this.noOfDaysLeft = firstResult.noOfDaysLeft;
          this.isCount = firstResult.unlockRfqCount;
          AppStorageUtil.setItem(
            "GrowthnoOfDaysLeft",
            this.noOfDaysLeft.toString()
          );
          AppStorageUtil.setItem("UnlockRfqCount", this.isCount.toString());
          AppStorageUtil.setItem(
            "isStarterPackageTaken",
            firstResult.isStarterPackageTaken
          );
          AppStorageUtil.setItem(
            "isStarterFreeTrialTaken",
            firstResult.isStarterFreeTrialTaken
          );
          if (this.isCount > 0) {
            this.remainingStatus = true;
            this.refreshCountShowStatus = false;
          } else if (this.isCount === 0) {
            this.refreshCountShowStatus = true;
            this.remainingStatus = false;
          }
          if (
            firstResult.isEligibleForGrowthPackage === 1 &&
            firstResult.isGrowthPackageTaken !== 1
          ) {
            this.isEligibleForGrowthPackage = true;
            this.isRemainingTileShow = false;
            this.isReadyForMoreImg = false;
          } else {
            this.isEligibleForGrowthPackage = false;
            this.isRemainingTileShow = true;
          }

          if (firstResult.accountType == appConstants.AccountType.Basic && firstResult.isRegistered == false) {
            this.toShowBillingMenu = false;
          }
          else
          {
            this.toShowBillingMenu = true;
          }
        }
      },
      (error) => {
        console.log("err", error);
      },

      () => { }

    );
  }

  mixPanelTracking(ev) {
    const submitModel = JSON.parse(AppStorageUtil.getItem("iContactViewModel"));
    var reqData = {
      "email": AppStorageUtil.getItem("User2"),
      "event": ev,
      "host": environment.AppUrl,
      "path": this.router.url,
      "ip": { ip: this.ipAddress },
      "browser": browserWindow.navigator.userAgent,
      "os": browserWindow.navigator.appVersion,
      "supplierName": submitModel.firstName + " " + submitModel.lastName,
    }
    this.rfqService.mixPanelStarter(reqData).subscribe((result: any) => {
      // console.log(result);
    });
  }

  redirectToCreateRfq(redirect, page) {
    if (redirect) {
      let url = environment.AppUrl;
        url = url + "#/rfq/buyer";
      browserWindow.location.replace(url);
    }
  }

  scheduleDemo() {
    if (this.loggedUserRole === appConstants.UserRole.Buyer) {
      browserWindow.open(environment.ScheduleDemoBuyerUrl)
    } else {
      browserWindow.open(environment.ScheduleDemoUrl)
    }
  }

  checkScheduleDemoStatus() {
    if (this.loggedUserRole === appConstants.UserRole.Buyer) {
      this.setScheduleDemoStatus()
    } else {
      if (this.accountType === appConstants.AccountType.Gold || this.accountType === appConstants.AccountType.Platinum) {
        this.showScheduleDemo = false;
        this.sidebarFixedNewHeight = "78%"
      } else {
        this.setScheduleDemoStatus()
      }
    }
  }

  setScheduleDemoStatus() {
    if (this.userLocation === 'US' || this.userLocation == 'Canada' || this.userLocation == 'Mexico / South America' || this.userLocation == 'Mexico') {
      this.showScheduleDemo = true;
    } else {
      this.showScheduleDemo = false;
      this.sidebarFixedNewHeight = "78%"
    }
  }
  ////////////////working till here
  parentLeftMenuClickHandler(item) {
    const collapseParent = !!(item.hasChildren && item.opened);

    this.leftMenu.forEach((element) => {
      element.opened = false;
    });

    if (!collapseParent) {
      item.opened = true;
    }

    if (item.icon === 'ti-email') {
      this.toggleLiveMessages();
    }
    if (item.icon === 'ti-bell') {
      this.toggleLiveNotification();
    }
    const isBuyerSupplierNetwork =
      this.userType === "Buyer" &&
      (item.name || "").toString().trim().toLowerCase() === "supplier network";
    if (isBuyerSupplierNetwork) {
      this.router.navigate(["/Supplier-network"]).then(() => {
        this.currentRoute = this.router.url;
        this.setActiveMenuExpanded();
      });
      return;
    }
    if (!item.hasChildren) {
      this.router.navigateByUrl(item.state).then(() => {
        this.currentRoute = this.router.url;
        this.setActiveMenuExpanded();
      });
      return;
    }
  }
  leftChildMenuClickHandler(item, subItem) {
    AppStorageUtil.removeSessionItem("materialsReferer");
    if (item.state === 'materialMenu') {
      if(subItem.state.includes('package')){
        this.router.navigateByUrl("/packages").then(() => {
          this.currentRoute = this.router.url;
          this.setActiveMenuExpanded();
        });
        return;
      }

      // Intercept Materials navigation for potential feedback popup
      const currentRoute = this.router.url;
      this.feedbackInterceptionService
        .requestExternalNavigation('materials', currentRoute)
        .subscribe(allowed => {
          if (allowed) {
            this.proceedWithMaterialsRedirect(subItem);
          }
        });
      return;
    } else if (item.state === 'messageMenu') {
      // For Messages menu, navigate directly to the child state (chat or globalMessage)
      // This allows "Inbox" (chat) to open TalkJS chat and "Archive" (globalMessage) to open archive
      const redirectURL = "/" + subItem.state;
      this.router.navigateByUrl(redirectURL).then(() => {
        this.currentRoute = this.router.url;
        this.setActiveMenuExpanded();
      });
      return;
    } else if (subItem.state === "buyerquotesv2") {
      this.router.navigateByUrl("/rfq/myqoutes").then(() => {
        this.currentRoute = this.router.url;
        this.setActiveMenuExpanded();
      });
      return;
    } else {
      const redirectURL = "/" + item.state + (subItem.state ? "/" + subItem.state : "");
      this.router.navigateByUrl(redirectURL).then(() => {
        this.currentRoute = this.router.url;
        this.setActiveMenuExpanded();
      });
    }
  }

  /**
   * Reads `hideAppChrome` from the current route tree (supports lazy-loaded children).
   */
  private syncHideAppChromeFromRoute(): void {
    let route: ActivatedRoute | null = this.activatedRoute;
    let hide = false;
    while (route) {
      const data = route.snapshot.data;
      if (data && data["hideAppChrome"] === true) {
        hide = true;
        break;
      }
      route = route.firstChild;
    }
    this.hideAppChrome = hide;
  }

  /**
   * Normalize route for comparison (remove query params and hash)
   */
  private normalizeRoute(route: string): string {
    if (!route) return '';
    // Remove query parameters and hash
    return route.split('?')[0].split('#')[0];
  }

  /**
   * Check if a parent menu item is active
   */
  isParentMenuActive(item: any): boolean {
    if (!item || !this.currentRoute) return false;

    const normalizedRoute = this.normalizeRoute(this.currentRoute);

    // If menu has children, check if any child is active
    if (item.hasChildren && item.children) {
      return item.children.some((child: any) => this.isChildMenuActive(item, child));
    }

    // For menus without children, check if the route matches
    if (item.state) {
      const routePath = "/" + item.state;
      const normalizedPath = this.normalizeRoute(routePath);
      return normalizedRoute === normalizedPath || normalizedRoute.startsWith(normalizedPath + "/");
    }

    const isBuyerSupplierNetwork =
      (item.name || "").toString().trim().toLowerCase() === "supplier network";
    if (isBuyerSupplierNetwork) {
      const snPath = this.normalizeRoute("/Supplier-network");
      return (
        normalizedRoute === snPath ||
        normalizedRoute.startsWith(snPath + "/")
      );
    }

    return false;
  }

  /**
   * Check if a child menu item is active
   */
  isChildMenuActive(item: any, subItem: any): boolean {
    if (!item || !subItem || !this.currentRoute) return false;

    const normalizedRoute = this.normalizeRoute(this.currentRoute);

    // Handle special cases
    if (item.state === 'messageMenu') {
      const routePath = "/" + subItem.state;
      const normalizedPath = this.normalizeRoute(routePath);
      return normalizedRoute === normalizedPath || normalizedRoute.startsWith(normalizedPath + "/");
    }

    if (item.state === 'materialMenu') {
      // Materials menu has special handling - external redirect
      return false;
    }

    if (subItem.state === "buyerquotesv2") {
      const myQuotesPath = this.normalizeRoute("/rfq/myqoutes");
      return (
        normalizedRoute === myQuotesPath ||
        normalizedRoute.startsWith(myQuotesPath + "/")
      );
    }

    // Standard route matching
    const routePath = "/" + item.state + (subItem.state ? "/" + subItem.state : "");
    const normalizedPath = this.normalizeRoute(routePath);
    return normalizedRoute === normalizedPath || normalizedRoute.startsWith(normalizedPath + "/");
  }

  /**
   * Get the active class for parent menu items
   */
  getParentMenuActiveClass(item: any): string {
    return this.isParentMenuActive(item) ? 'active' : '';
  }

  /**
   * Get the active class for child menu items
   */
  getChildMenuActiveClass(item: any, subItem: any): string {
    return this.isChildMenuActive(item, subItem) ? 'active' : '';
  }

  /**
   * Auto-expand parent menu if any child is active
   */
  setActiveMenuExpanded(): void {
    if (!this.leftMenu || !this.currentRoute) return;

    this.leftMenu.forEach((item: any) => {
      if (item.hasChildren && item.children) {
        const hasActiveChild = item.children.some((child: any) =>
          this.isChildMenuActive(item, child)
        );
        if (hasActiveChild) {
          item.opened = true;
        }
      }
    });
  }

  /**
   * Proceed with Materials application redirect after feedback popup (if shown)
   */
  private proceedWithMaterialsRedirect(subItem): void {
    this.showDataLoading = true;
    this.profileService.validateUserAndGenerateToken(this.loggedId).subscribe((response) => {
      if (response.status) {
        const materialRedirectURL = `${environment.RedirectToMaterialPage}auth/sso?token=${response.token}&redirectTo=supplier/${(subItem.state ? "/" + subItem.state : "")}&sb=${this.showBubble}&smc=${(this.showMessage) || this.newMessageCount > 0 }`;
        browserWindow.location.href = materialRedirectURL;
        this.showDataLoading = false;
        return;
      }
      this.toastr.warning("Please try again");
      console.error('Token generation failed');
    });
  }

  showDataLoading: boolean = false;

  navigateToSupplierBuyerNetwork(): void {
    this.router.navigate(["/supplier-buyer-network"]);
  }

  private refreshSupplierNetworkMyBuyersMenu(): void {
    if (this.userType !== "Supplier") {
      this.showSupplierNetworkMyBuyersMenu = false;
      return;
    }

    const inviteSource =
      this.iContactViewModel1?.inviteSource ??
      this.getInviteSourceFromStorage();
    this.showSupplierNetworkMyBuyersMenu =
      (inviteSource || "").trim() === "Supplier Network";
  }

  private getInviteSourceFromStorage(): string | null {
    try {
      const raw = AppStorageUtil.getItem("iContactViewModel");
      if (!raw) {
        return null;
      }
      const model = JSON.parse(raw) as IContactViewModel;
      return model?.inviteSource ?? null;
    } catch {
      return null;
    }
  }

  reloadDashBoardComp() {
    AppStorageUtil.removeSessionItem("materialsReferer");
    const userType = this.isBuyerProfile();
    let url: string;

    if (userType === "Supplier") {
      url =
        this.userLocation === "US" || this.userLocation === "Canada"
          ? "/dashboard/supplier"
          : "/dashboard/supplier/ecommerce/";
    } else if (userType === "Buyer") {
      url = "/dashboard/buyer/default/";
    } else {
      url = "/dashboard/buyer/default/";
    }
    this.router.navigate([url], {
      queryParams: { reload: new Date().getTime() },
    });
  }

  /**
   * Buyer sidebar: enrich API menu (e.g. NDA tooltip, Supplier Network route).
   */
  private normalizeBuyerLeftMenu(menuDetails: any[]): any[] {
    if (this.userType !== "Buyer") {
      return menuDetails;
    }
    const menu = menuDetails || [];
    this.normalizeBuyerSupplierNetworkMenuItem(menu);
    this.enrichBuyerNdaSubmenuItem(menu);
    return menu;
  }

  /**
   * Buyer sidebar: API may return an incorrect `state` for Supplier Network.
   * Top-level app route `/Supplier-network` (see app-routing + SupplierNetworkModule).
   */
  private normalizeBuyerSupplierNetworkMenuItem(menuDetails: any[]): void {
    for (const m of menuDetails || []) {
      if (!m) {
        continue;
      }
      const name = (m.name || "").toString().trim().toLowerCase();
      if (name === "supplier network") {
        m.state = "Supplier-network";
        m.hasChildren = false;
        break;
      }
    }
  }

  /**
   * RFQs → NDAs: tooltip + "New" badge (API menu may omit these fields).
   */
  private enrichBuyerNdaSubmenuItem(menuDetails: any[]): void {
    const rfqGroup = menuDetails.find(
      (m: any) => m.state === "rfq" && m.hasChildren && Array.isArray(m.children)
    );
    if (!rfqGroup) {
      return;
    }
    const ndaChild = rfqGroup.children.find((c: any) => c.state === "rfqnda");
    if (!ndaChild) {
      return;
    }
    if (!ndaChild.tooltip) {
      ndaChild.tooltip =
        "NDA Receipt Download\nYou can now download proof that suppliers accepted your NDA.";
    }
    ndaChild.showNewBadge = true;
  }

 }
